module.exports = __webpack_public_path__ + "img/ZX2.0a8d7658.jpg";